// eslint-disable-next-line import/prefer-default-export
export const adjustDate = dateStr =>
  dateStr.replace("1970", new Date().getFullYear()); // <- dates are annoying - to ensure the time doesn't change to an hour ahead or behind when clocks change as it will not work correctly if year is 1970-...
